import styled, { CSSProperties } from "styled-components";
import themeProps from "theme/themes";

interface TextareaProps {
  value: string;
  label?: string;
  placeholder: string;
  onChange: any;
  autoFocus?: boolean;
  styles?: CSSProperties;
}

const Wrapper = styled.div`
  width: 100%;
`;
const Label = styled.h3`
  margin-bottom: 8px;
`;
const Input = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid ${(state: themeProps) => state.theme.border.secondary};
  outline: none;
  resize: none;
  font-family: inherit;
`;

const Textarea = ({
  value,
  label,
  placeholder,
  onChange,
  autoFocus,
  styles,
}: TextareaProps) => {
  return (
    <Wrapper style={styles}>
      {label ? <Label>{label}</Label> : null}
      <Input
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        autoFocus={autoFocus}
      />
    </Wrapper>
  );
};

export default Textarea;
